/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { fmtMoney } from '@upstart/harmony/lib/formatter';
import CarImage from '../../CarImage/CarImage';
import '../Feedview.scss';

const vehicleCard = props => {
  const { id, vehicle, dealer } = props;

  const getVehicleName = () => (
    <div className="vehicle-card-name-container">
      <span className="vehicle-name">{vehicle.name}</span>
    </div>
  );

  return (
    <div className="vehicle-card-container" id={id}>
      <div className="vehicle-card-image-container">
        {vehicle && <CarImage car={vehicle} dealer={dealer} />}
      </div>
      <div id={`${id}-name`} className="vehicle-card-name">
        {getVehicleName()}
      </div>
      <div className="vehicle-card-price-info-container">
        <div className="vehicle-card-price-info">
          <span className="vin" id={`${id}-stock`}>
            Stock
            <span className="vin-value"> {vehicle.stock}</span>
          </span>
        </div>
        <div className="vehicle-card-price-info">
          <span className="price" id={`${id}-stock`}>
            Price
            <span className="price-value">
              {' '}
              {fmtMoney(vehicle.cachedOnlinePrice)}
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};

vehicleCard.propTypes = {
  id: PropTypes.string,
  vehicle: PropTypes.object,
  dealer: PropTypes.object,
};

export default vehicleCard;
